export const authenticatedLayoutTexts = {
    openAvatar: 'Open avatar',
};
